import { render } from "./IconProductsPurchased.vue?vue&type=template&id=e02f4950"
import script from "./IconProductsPurchased.vue?vue&type=script&lang=js"
export * from "./IconProductsPurchased.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__